import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useSetState from '../../../../hooks/useSetState';
import { getReservationTimingList } from '../../../../redux/reservationTiming/actions';
import { Link } from 'react-router-dom';
import ReservationTimingFilter from '../Filter/ReservationTimingFilter';
import { getAllCafeNamesForPanel } from '../../../../redux/cafes/actions';
import Spin from '../../../../components/loading';
import submitForm from '../../../../utils/submitForm';
import Table from '../../../../components/table';
import { reservationTimingColumns } from '../../../../enums/columns/reservationTiming';
import { permissionHelper } from '../../../../utils';
import ENUMS from '../../../../enums';
import ShowForPermission from '../../../../components/ShowForPermission';

const ReservationTimingIndex = () => {
  const [controls, setControls] = useSetState({
    filter: '',
    sort: { sortType: 'desc', sortBy: 'date', sortQuery: '', filterQuery: '' },
    query: '',
    selectedRegions: [],
    selectedAmenities: [],
    pageNumber: 1,
    pageSize: 10,
  });

  const onChangeValue = (controleName, value) => {
    setControls({ [controleName]: value });
  };

  const dispatch = useDispatch();

  const hasRseeAdminPermission = permissionHelper.hasUserPermission(
    ENUMS.PERMISSIONS.values
      .AUTO_GENERATE_RESERVE_DATES_AND_HOURS_FOR_ALL_CAFES,
  );

  useEffect(() => {
    // getReservationList(controls.pageNumber, controls.pageSize);
    if (hasRseeAdminPermission) {
      dispatch(getAllCafeNamesForPanel())
    }
  }, []);

  const { reservationTimingList,
    totalRecords,
    cafeNamesList,
    getAllReservationTimingLoading, } = useSelector(state => ({
      reservationTimingList: state.reservationTimetableReducer.reservationTimingList,
      totalRecords: state.reservationTimetableReducer.totalRecords,
      cafeNamesList: state.cafesReducer.cafeNamesList,
      getAllReservationTimingLoading: state.reservationTimetableReducer.getAllReservationTimingLoading,
    }));

  const getReservationList = (pageNumber, pageSize) => {
    const query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
    dispatch(getReservationTimingList(query))
      .then(result => {
        setTotalRecords(result.payload.totalRecords);
        onChangeValue('pageNumber', result.payload.pageNumber);
        onChangeValue('pageSize', result.payload.pageSize);
      })
      .catch(error => console.log('error', error));
  };

  const buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&sort=${controls.sort.sortQuery || 'date-desc'}`;
      if (controls.sort.filterQuery) {
        query += '&' + controls.sort.filterQuery;
      }
      return query;
    }
  };

  const onPageChanged = pageNumber => {
    onChangeValue('pageNumber', pageNumber);
    const query = buildSearchQuery(pageNumber, controls.pageSize);
    dispatch(getReservationTimingList(query));
  };

  const sortTable = (columnName) => {
    const sortType = controls.sort.sortType === 'asc' ? 'desc' : 'asc';
    onChangeValue('sort', { ...controls.sort, sortType, sortBy: columnName });
  };

  const filterAndSort = () => {
    let searchQuery = buildSearchQuery(1, controls.pageSize);
    dispatch(getReservationTimingList(searchQuery));
  };

  const applyFilters = (event, cafeIds) => {
    event.preventDefault();
    const queryString = submitForm(event,
      controls.selectedRegions,
      controls.selectedAmenities,
      cafeIds);
    onChangeValue('sort', { ...controls.sort, filterQuery: queryString });
  };

  const resetForm = () => {
    onChangeValue('pageNumber', 1);
    onChangeValue('sort', { ...controls.sort, filterQuery: '' });
  };

  useEffect(() => {
    sortTable(controls.sort.sortBy);
  }, []);

  useEffect(() => {
    const sortQuery = `${controls.sort.sortBy}-${controls.sort.sortType}`;
    onChangeValue('sort', { ...controls.sort, sortQuery });
  }, [controls.sort.sortType]);

  useEffect(() => {
    if (controls.sort.sortQuery !== '') {
      onChangeValue('pageNumber', 1);
      filterAndSort();
    }
  }, [controls.sort.sortQuery]);

  useEffect(() => {
    if (controls.sort.filterQuery !== '') {
      onChangeValue('pageNumber', 1);
      filterAndSort();
    }
  }, [controls.sort.filterQuery]);

  return (
    <Spin spinning={getAllReservationTimingLoading}>
      <section>
        <div className="col-12 d-flex justify-content-between align-items-center">
          <h3 className="text-right text-muted py-4">
            {locales('insert.new.reservation.timing')}
          </h3>
          <ShowForPermission permission={ENUMS.PERMISSIONS.values.ADD_NEW_CAFE_SCHEDULE}>
            <Link to="/reservation-timing/new-timing"
              className="btn btn-primary w-5 mx-1">
              <i className="fal fa-plus mx-1" />
              {locales('new.reservation.timing')}
            </Link>
          </ShowForPermission>
        </div>
        <ReservationTimingFilter
          data={cafeNamesList}
          applyFilters={applyFilters}
          getReservationList={getReservationList}
          pageNumber={controls.pageNumber}
          pageSize={controls.pageSize}
          resetForm={resetForm}
        />

        <div className='bg-white p-2'>
          <div className="panel-heading">
            <i className="fas fa-list-alt px-1" />
            {locales('reservation.timetable')}
          </div>
          <div className='table-responsive-lg'>
            <Table
              columns={reservationTimingColumns}
              dataSource={reservationTimingList}
              loading={getAllReservationTimingLoading}
              sort={{ type: controls.sortType, action: sortTable }}
              pagination={{
                currentPage: controls.pageNumber,
                pageSize: controls.pageSize,
                totalCount: totalRecords || 0,
                onPageChange: onPageChanged,
              }}
            />
          </div>
        </div>
      </section>
    </Spin>
  );
}

export default ReservationTimingIndex;